<template>
  <div class="device_not_connect">
    <img class="device_img margin_bottom" :src="currentDevice.icon" />
    <div class="message_action_kb">
      <div class="kb_message">{{ $t('message_device_fe87v2_error') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentDevice } from '../../profiles/selector'
import { computed } from 'vue'
const currentDevice = computed(() => getCurrentDevice.value)
</script>

<style scoped lang="less">
.device_not_connect {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  width: 100%;
  flex: 1;

  .exit_sleep {
    margin-top: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-app-region: no-drag;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    padding-left: 30px;
    padding-right: 30px;
    color: #ffffff;
    border-radius: var(--radius-s);
    border: 1px solid #ffffff;
  }
}

.message_top_abnormal {
  background-color: rgba(#ffffff, 0.2);
  border-radius: var(--action-btn-radius);
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.device_img {
  object-fit: contain;
  width: 800px;
  height: 400px;
  margin-top: 40px;
  margin-bottom: 43px;

  &.margin_bottom {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
}

.message_action {
  font-size: 30px;
  color: #fff;
  text-align: center;
}

.message_action_kb {
  text-align: start;
  max-width: 904px;

  .kb_message {
    font-size: 20px;
    margin-top: 12px;
    line-height: 1.5;

    .kb_message:nth-child(1) {
      margin-top: 0px;
    }
  }
}
</style>
